import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Zone from "@frog/source/models/Zone.js"

// let UnitSprite = function() {}
// import("@frog/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
// import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
// import Dice from "@frog/source/data/games/dice/views/Dice.jsx"
// import DiceCube from "@frog/source/data/games/dice/views/DiceCube.jsx"
// import DiceLayout from "@frog/source/data/games/dice/views/DiceLayout.jsx"

import {Roll} from "@frog/source/data/games/dice/scripts/Rolling.js"
import CarryOn from "@frog/source/data/games/dice/scripts/CarryOn.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import Audiomix from "@frog/source/engine/Audiomix.js"

import "./Huds.less"

// function onClickUnit(unit) {
//     return function(event) {
//         unit.isLockedIn = !unit.isLockedIn
//     }
// }

function canReroll(stage) {
    return stage.player.rollcount >= 1
        && Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.isLockedIn != true
                && unit.affiliation == stage.player.affiliation
                && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
        }).length > 0
}

function onClickReroll(stage) {
    return function(event) {
        if(stage.player.rollcount <= 0) return
        const units = Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.isLockedIn != true
                && unit.affiliation == stage.player.affiliation
                && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
        })
        if(units.length == 0) return
        stage.player.rollcount -= 1
        Object.values(stage.units).forEach((unit) => {
            if(unit.isLockedIn) return
            if(unit.affiliation != stage.player.affiliation) return
            unit.rollcount = stage.player.rollcount
            unit.primaryItem = stage.random.element(Object.values(unit.diceFaces))
            unit.equippedItem = unit.primaryItem
            // if(stage.player.rollcount == 0) {
            //     unit.isLockedIn = true
            // }
        })
        Audiomix.trigger("Dice:Roll")
    }
}

function onClickDone(stage) {
    return function(event) {
        Object.values(stage.units).forEach((unit) => {
            delete unit.isLockedIn
        })

        stage.player.phase = "playing"
        stage.player.zoomout = 1
        Stage.calculateActions(stage, {"force": true})

        // Step.deltastage({
        //     "player": {
        //         "phase": "playing",
        //         "zoomout": 1,
        //     },
        // }),
        // {
        //     "duration": 1200,
        //     "deltastages": [
        //         {
        //             "dialogue": {
        //                 "type": "TurnStart",
        //                 "data": {"affiliation": "good"},
        //             }
        //         }
        //     ]
        // },
        // PlotSteps.PlayStinger("Stinger:EnemyTurn"),
    }
}

export default function RollingHud(stage) {
    if(stage.player.phase != "rolling") return
    return (
        <div class="RollingHud">
            <div class="RerollButton" onClick={onClickReroll(stage)} isEnabled={canReroll(stage) == true}>
                Reroll ({stage.player.rollcount} of 3)
            </div>
            <div class="DoneButton" onClick={onClickDone(stage)} isEnabled={true} isHighlighted={canReroll(stage) == false}>Done</div>
        </div>
    )
}
